// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_1-udb","button":"view-header_button_iFnNt","active":"view-header_active_iWAem","btnExport":"view-header_btnExport_7Q5DW","mr":"view-header_mr_tLbQn"};